export const STORAGE_KEYS = {
    SESSION_ID: 'sessionId',
    HAS_SEEN_ONBOARDING: 'hasSeenOnboarding',
    WIDGET_AUTH_TOKEN: 'widget_auth_token',
    MESSAGE_FEEDBACK: 'message_feedback'
  } as const;
